import ENUMS from '@core/classes/Enums';
export default class FIMenuCreditPulls {
	// customerApplicationID:  string | null;
	// dateCreated:            string | null;
	// id:                     string | null;
	// lastModified:           string | null;
	// primaryCustomerID:      string | null;
	// redFlags:               RedFlag | null;
	// request:                Request | null;
	// Response:               Response | null;

	constructor(init) {
		if (init) {
			this.customerApplicationID = init.customerApplicationID;
			this.dateCreated = init.dateCreated;
			this.id = init.id;
			this.lastModified = init.lastModified;
			this.primaryCustomerID = init.primaryCustomerID;
			this.redFlags = init.redFlags?.map(rf => new RedFlag(rf)) ?? [];
			this.request = new Request(init.request);
			this.response = init.response;
		} else {
			this.customerApplicationID = null;
			this.dateCreated = null;
			this.id = null;
			this.lastModified = null;
			this.primaryCustomerID = null;
			this.redFlags = [];
			this.request = new Request();
			this.response = null;
		}
	}

	getCreditPullsFromType(cp) {
		if (this.request.header_data.action == cp) {
			return this.response.creditreport.report;
		}
	}

	filteredPullHistoryForBureau(reportType) {
		let bureauType = ENUMS.CBC_REPORT_TYPES.reportTypeEnumToString(reportType);
		let creditPulls = this.customer.creditPulls;
		let filter = creditPulls.filter(cp => {
			return cp.request.header_data.action == bureauType;
		});
		return filter;
	}
}

class RedFlag {
	constructor(init) {
		if (init) {
			this.code = init.code;
			this.reason = init.reason;
			this.type = init.type;
		} else {
			this.code = null;
			this.reason = null;
			this.type = null;
		}
	}
}

class Request {
	constructor(init) {
		if (init) {
			this.header_data = new HeaderData(init.header_data);
		} else {
			this.header_data = new HeaderData();
		}
	}
}

// action:                  string | null;
// products:                string | null;
// productName:             string | null;
class HeaderData {
	constructor(init) {
		if (init) {
			this.action = init.action; // TU, EFX, OFAC,
			this.products = init.products; // THIS WILL BE FOR THE VERSION TYPE
			// this.productName   = init.productName
		} else {
			this.action = null;
			this.products = null;
			// this.productName   = null;
		}
	}
}
